<template>
  <el-dialog
    class="ts-modal ts-modal--sga no-padding"
    :visible="showMatchModal"
    width="800px"
    title="Role Matches"
  >
    <button
      type="button"
      aria-label="Close"
      class="el-dialog__headerbtn"
      @click="onCloseDialog"
    >
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>

    <span class="h5 border-modal">Role Matches</span>
    <div style="padding-top:5px; padding-bottom:5px;">
      <span style="font-size: 18px;font-weight: bold;padding-left: 420px">Filter by Distance </span>
      <el-select v-model="value" placeholder="Select" style="width: 200px;" @change="filteredBy()">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="ts-matches" 
      v-if="matches != 0"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div
        class="ts-matches--match"
        v-for="(match, index) in matches"
        :key="index"
        :class="{ 'top-match': index == 0 }"
      >
        <span class="ts-matches--match_topmatch" v-if="index == 0"
          ><v-icon name="crown"/> Best Match <i></i
        ></span>
        <div class="ts-matches--match_top">
          <div class="ts-matches--match_info">
            <span v-if="match.Image !== 'na'" class="match_image">
              <img
                :src="match.Image"
                :alt="match.Name"
              />
            </span>
            <span v-if="match.Image === 'na'" class="match_image">
              <img
                v-bind:src="'https://ui-avatars.com/api/?name='+ `${match.companyName}` + '&background=14223C&color=fff'"
                :alt="match.Name"
              />
            </span>
            <div>
              <div class="match_title">
                {{ match.CompanyName }}
              </div>
              <div class="match_department">
                {{ match.Department }}
              </div>
            </div>
          </div>
          <div class="ts-matches--match_actions">
            <button class="ts-btn ts-btn-small"  @click="viewRole(match)">
              View Role
            </button>
            <button class="ts-btn ts-btn-small" disabled v-if="match.invitation === 'INPROGRESS'">
              * In progress!
            </button>
            <button class="ts-btn ts-btn-small ts-btn-outline" @click="applyForRole(match, $event)" v-if="match.invitation === 'NONE'">
              Apply for Role
            </button>
          </div>
        </div>

        <div class="ts-matches--match_bottom">
          <div class="match_percent">
            <el-progress
              type="circle"
              :width="50"
              :stroke-width="4"
              color="#14223C"
              :percentage="Math.round(match.percentMatch)"
            ></el-progress>
          </div>
          <div class="match_upskilling" v-if="match.percentMatch === '0.00'">
              <span>Please complete your profile to see if your skills match this role.</span>
          </div>
          <div class="match_upskilling" v-if="match.percentMatch !== '0.00'">
            <strong>Recommended Upskilling</strong>
            <ul>
              <li
                v-for="(skill, index) in match.upSkillingRequired"
                :key="index">
                <span>{{ skill.selection }}</span>
                <span v-if="(index + 1) != match.upSkillingRequired.length">,</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="matches == 0">
      <el-alert :closable="false" :title="noDataText" type="error"></el-alert>
      <div style="width:800px; height:300px;">
        <div v-if="!areMatchesLoading" class="no-data">
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
          </span>
        </div>
        <!-- <loading 
          :active.sync="areMatchesLoading"
          :can-cancel="false"
          :is-full-page="false">
        </loading> -->

        <TSLoading :active="areMatchesLoading" :defaultMessage="'Please wait...'" :altMessage="'Please hold on for a moment while we process the data...'"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VueCircle from 'vue2-circle-progress';
import VacantRoleInfo from '../components/VacantRoleInfo.vue';
import TSLoading from '../../../components/TSLoading.vue';

export default {
    created() {
        this.areMatchesLoading = true;
        this.noDataText = 'Retrieving matches...';
        this.$store.dispatch('jobseeker/getRoleMatches', this.$store.state.account.current_user.id)
        .then((res) => {
            this.matches = res;
            this.areMatchesLoading = false;
            this.loading = false;
            this.noDataText = 'There are no current matches';
        });
    },
  components: {
    VueCircle,
    VacantRoleInfo,
    TSLoading
  },
  data() {
    return {
      matches: [],
      showMatchModal: true,
      showJobSeeker: true,
      showPane: false,
      selectedRole: {},
      areMatchesLoading: false,
      noDataText: '',
      options: [{
          value: '9',
          label: 'Less than 10 miles'
        }, {
          value: '10',
          label: 'more than 10 miles'
        }, {
          value: '20',
          label: 'more than 20 miles'
        }, {
          value: '50',
          label: 'more than 50 miles'
        }, {
          value: '100',
          label: 'more than 100 miles'
        }],
        value: '',
        loading: true,
    };
  },
  watch: {
    showMatchModal(v) {
      if (v === false);
      this.$emit('on-close-dialog');
    }
  },
  computed: {
    dataItems() {
      return this.user.FullSGA;
    },
    currentJobSeeker() {
      return this.$store.state.account.current_user;
    },
  },
  beforeDestroy() {
    this.matches = [];
  },
  mounted() {
    
  },
  methods: {
    viewRole(match){
        this.$router.push({ name: 'VacantRoleInfo' , params: { role: match }});
    },
    applyForRole(match, e){
      this.$router.push({ name: 'ConfirmApplyForRoleDialog', params: { data: match }});
      e.currentTarget.innerText = "* In progress!";
      e.currentTarget.disabled = true
    },
    onCloseDialog(){
      
        this.$router.push({ name: 'jobseeker-dashboard' });
        this.showMatchModal = false;
    },
    handleCloseModal() {
      this.showPane = false;
    },
    filteredBy() {
      this.loading = true;
      var zip_codes = [];
      this.filteredMatches = [];

      var param = {};
      param.ZipCode = this.currentJobSeeker.ZipCode;
      param.Miles = this.value;
      
      this.$store.dispatch('organisation/getZipCodes', param)
        .then((res) => {
          zip_codes = res.zip_codes;
          //zip_codes = res.Result.zip_codes;
        })
        .finally((res) => {
          var matched = this.matches;
          const find = (_matches, _zipcodes) => {
            _matches.forEach(m => {
              _zipcodes.forEach(z => {
                if(m.ZipCode != "NA") {
                  if(z.zip_code == m.ZipCode) {
                    this.filteredMatches.push(m);
                  }
                }
              });              
            });
          };

          find(matched, zip_codes);
          this.matches = [];
          this.matches = this.filteredMatches;    
          this.loading = false;     
          
        });
    },
  }
};
</script>

<style scoped>
  .no-data {
    width: 100%;
    height: 100%;
    align-content: center;
    text-align: center;
    font-size: 110px;
    color: lightgray;
    margin-top: 10px;
  }

  .border-modal {
    border-bottom: 2px solid #e7e2e2
  }
</style>
